/**
 * Adds dns-prefetch + preconnect for REACT_APP_API_URL so the first credentialed
 * API calls (e.g. GET /api/clients) start DNS/TLS earlier. Safe no-op if env missing or invalid.
 */
export default function injectApiResourceHints() {
  if (typeof document === 'undefined') return;

  const raw = process.env.REACT_APP_API_URL;
  if (!raw || typeof raw !== 'string') return;

  let origin;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const trimmed = raw.trim();
    const url = trimmed.startsWith('http://') || trimmed.startsWith('https://')
      ? new URL(trimmed)
      : new URL(trimmed.startsWith('/') ? trimmed : `/${trimmed}`, base);
    origin = url.origin;
  } catch (e) {
    return;
  }

  if (typeof window !== 'undefined' && window.location.origin === origin) {
    return;
  }

  const mark = 'data-soothe-api-hint';
  if (document.head.querySelector(`link[rel="preconnect"][${mark}]`)) return;

  const dns = document.createElement('link');
  dns.rel = 'dns-prefetch';
  dns.href = origin;
  dns.setAttribute(mark, '1');

  const pc = document.createElement('link');
  pc.rel = 'preconnect';
  pc.href = origin;
  pc.setAttribute(mark, '1');

  document.head.appendChild(dns);
  document.head.appendChild(pc);
}
